const $       = require('jquery');
const eventer = require('../util/eventer');

function Modal(options) {
  let api = eventer({});
  let isOpen = false;
  let modal = null;

  function open() {
    if (isOpen) return;
    isOpen = true;

    modal = $(`
      <div class="modal-backdrop">
        <div class="modal-box"></div>
      </div>
    `).click(function(e) {
      if (options.no_close) return;
      if ($(this).is(e.target)) api.trigger('cancel');
    }).addClass(options.css_class || '');

    modal.find('.modal-box').append(options.content);
    modal.appendTo(document.body);

    setTimeout(() => modal.addClass('visible'), 0);

    $(window).on('keydown.modal', e => {
      if (e.keyCode != 27) return; // escape
      $(window).off('keydown.modal');
      api.trigger('cancel');
    });

    return api;
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;

    modal.one('transitionend', () => modal.detach());
    modal.removeClass('visible');

    return api;
  }

  api.on('cancel', close);

  api.open  = open;
  api.close = close;

  Object.defineProperty(api, 'isOpen', {
    get() { return isOpen; }
  });

  return api;
}

module.exports = Modal;
